import ApiClient from './ApiClient';

class ContactReasonsAPI extends ApiClient {
  constructor() {
    super('contact_reasons', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new ContactReasonsAPI();
